import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";
import { toNumber } from "lodash-es";

import { AamsGameDataAction } from "./aams-game-data.action";
import { AamsGameDataContextState, AdditionalParameters, ProviderDataKeys } from "./aams-game-data.model";

export const INITIAL_STATE: AamsGameDataContextState = {
	activeGame: {},
	additionalParameters: {},
	path: "",
	isSessionDisplayed: false,
};

export const aamsGameDataReducer = createReducer(
	INITIAL_STATE,
	on(AamsGameDataAction.gameReady, (state, { data }) =>
		updateState(state, {
			activeGame: {
				...state.activeGame,
				aamsSessionId: data[ProviderDataKeys.AamsSessionId],
				aamsTicketId: data[ProviderDataKeys.AamsTicketId],
				aamsOnlyFreeSpinAllowed: data[ProviderDataKeys.AamsOnlyFreeSpinAllowed],
				aamsSessionAmount: data[ProviderDataKeys.AamsSessionAmount],
				aamsCurrencyCode: data[ProviderDataKeys.AamsCurrencyCode],
				aamsMoneyType: data[ProviderDataKeys.AamsMoneyType],
				historyUrl: data[ProviderDataKeys.HistoryUrl],
			},
		})
	),
	on(AamsGameDataAction.setIsSessionDisplayed, (state, { isSessionDisplayed }) =>
		updateState(state, {
			isSessionDisplayed,
		})
	),
	on(AamsGameDataAction.gameRemove, (state) =>
		updateState(state, {
			...INITIAL_STATE,
		})
	),
	on(AamsGameDataAction.getAdditionalParameters, (state, { data }) => {
		const additionalParameters: Record<string, string> = {};
		let path = "";
		let isEvent = true;
		let isLive = false;
		let isSharedCode = false;

		data.split("/").forEach((element) => {
			if (!element) {
				return;
			}
			const elParts = element.split("-");
			const lastElPart = elParts[elParts.length - 1];
			const id = toNumber(lastElPart);

			if (!path) {
				path = elParts[0];
				if ((isLive = elParts.length > 1)) {
					additionalParameters[AdditionalParameters.Tab] = lastElPart;
				}
			} else if (isSharedCode) {
				additionalParameters[AdditionalParameters.SharedCode] = element.toUpperCase();
			} else if (!additionalParameters[AdditionalParameters.Tab]) {
				if (!(isSharedCode = element === AdditionalParameters.Shared)) {
					additionalParameters[AdditionalParameters.Tab] = element;
				}
			} else if (isLive) {
				if (!isNaN(id)) {
					additionalParameters[AdditionalParameters.LiveId] = lastElPart;
					delete additionalParameters[AdditionalParameters.Tab];
				}
			} else if (isEvent && !additionalParameters[AdditionalParameters.EventId]) {
				if ((isEvent = !isNaN(id))) {
					additionalParameters[AdditionalParameters.EventId] = lastElPart;
					delete additionalParameters[AdditionalParameters.Tab];
				}
			} else if (!isNaN(id)) {
				additionalParameters[AdditionalParameters.SubeventId] = lastElPart;
				delete additionalParameters[AdditionalParameters.Tab];
			}
		});

		return updateState(state, {
			additionalParameters,
			path,
		});
	}),
	on(AamsGameDataAction.gameSessionUpdated, (state, { data }) =>
		updateState(state, {
			activeGame: {
				...state.activeGame,
				aamsSessionId: data[ProviderDataKeys.AamsUpdateSessionId],
				aamsTicketId: data[ProviderDataKeys.AamsUpdateTicketId],
			},
		})
	)
);
